// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vae-card {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  margin-bottom: 1rem;
  overflow: hidden;
}

.vae-card-header {
  font-size: 1rem;
  font-weight: 500;
  color: #1f2937;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  margin: 0;
  background-color: #f9fafb;
}

.vae-card-content {
  padding: 1rem;
}

.vae-stepper-value {
  min-width: 4rem;
  text-align: center;
  font-weight: 500;
  font-size: 1rem;
  color: #111827;
  padding: 0 0.25rem;
}

.vae-card-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.vae-numeric-stepper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.vae-stepper-label {
  margin-right: 1rem;
  font-weight: 450;
  font-size: 1rem;
  color: #4b5563;
}

.vae-stepper-controls {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.vae-stepper-button {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  color: #374151;
  width: 2rem;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.vae-stepper-button:hover {
  background-color: #f3f4f6;
}

.vae-stepper-button:active {
  background-color: #e5e7eb;
}

.vae-stepper-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f9fafb;
}

.vae-dropdown-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.vae-dropdown-label {
  margin-right: 1rem;
  font-weight: 450;
  font-size: 1rem;
  color: #4b5563;
  flex-shrink: 0;
}

.vae-select-wrapper {
  position: relative;
  display: inline-block;
  max-width: 320px;
}

.vae-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  padding: 0.5rem 2rem 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.5;
  color: #111827;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.vae-select:hover {
  border-color: #9ca3af;
}

.vae-select:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}

.vae-select-wrapper::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 1rem;
  width: 0;
  height: 0;
  margin-top: -2px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #6b7280;
  pointer-events: none;
}

.vae-select-wrapper:hover::after {
    border-top-color: #374151;
}

.vae-switch-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.vae-switch-label {
  margin-right: 1rem;
  font-weight: 500;
  color: #374151;
  font-size: 0.9rem;
  flex-shrink: 0;
  cursor: pointer;
}

.vae-label-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.vae-control-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: #4b5563;
}

.vae-control-icon svg {
  width: 16px;
  height: 16px;
}

.vae-numeric-stepper,
.vae-dropdown-container,
.vae-switch-container {
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 8px;
}

.vae-text-settings-container {
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.vae-text-settings-container .vae-numeric-stepper,
.vae-text-settings-container .vae-dropdown-container {
  background-color: transparent;
  border-radius: 0;
  padding: 4px 0;
  margin-bottom: 4px;
}

.vae-text-settings-container > *:last-child {
  margin-bottom: 0;
}

.vae-stepper-label,
.vae-dropdown-label,
.vae-switch-label {
  margin-right: 0;
  font-weight: 450;
  font-size: 0.9rem;
  color: #4b5563;
}

.vae-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  background-color: #ccc;
  border-radius: 34px;
  cursor: pointer;
  transition: background-color 0.2s;
  border: 1px solid #ccc;
  padding: 0;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  box-sizing: content-box;
}

.vae-switch:focus-visible {
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}

.vae-switch-knob {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.2s;
}

.vae-switch-checked {
  background-color: #2563eb;
  border-color: #2563eb;
}

.vae-switch-checked .vae-switch-knob {
  transform: translateX(18px);
}

.vae-numeric-stepper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vae-overlay {
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  background-color: var(--vae-modal-bg, white);
  z-index: 10;
  display: none;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  max-height: none;
  min-height: 0;
}

.vae-overlay.active {
  display: flex;
}

.vae-overlay-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem var(--vae-container-padding, 1rem);
  border-bottom: 1px solid var(--vae-border-light, #e5e5e5);
  background-color: var(--vae-modal-bg, white);
  z-index: 2;
  position: relative;
}

.vae-overlay-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--vae-modal-text, #262626);
}

.vae-overlay-close {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 0.375rem;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: color 0.2s ease;
  color: var(--vae-footer-text, #6b7280);
  position: static;
  top: auto;
  right: auto;
  z-index: 1;
  gap: 0.5rem;
}

.vae-overlay-close svg {
  width: 1.25rem;
  height: 1.25rem;
}

.vae-back-text {
  font-size: 0.875rem;
  font-weight: 500;
}

.vae-overlay-close:hover {
  color: var(--vae-modal-text, #262626);
  background-color: transparent;
}

.vae-overlay-content {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding: var(--vae-content-padding, 1rem);
}

.vae-overlay-content p {
  margin-bottom: 1rem;
  line-height: 1.5;
  color: var(--vae-modal-text-secondary, #4b5563);
}

.vae-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.vae-form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.vae-form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--vae-modal-text-secondary, #4b5563);
}

.vae-form-input,
.vae-form-textarea {
  padding: 0.625rem;
  border: 1px solid var(--vae-border-light, #d1d5db);
  border-radius: 0.375rem;
  font-size: 0.875rem;
  color: var(--vae-modal-text, #111827);
  background-color: var(--vae-bg-light, white);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  font-family: inherit;
}

.vae-form-input:focus,
.vae-form-textarea:focus {
  outline: none;
  border-color: var(--vae-primary-color, #3B82F6);
  box-shadow: 0 0 0 2px rgba(var(--vae-primary-rgb, 59, 130, 246), 0.25);
}

.vae-form-textarea {
  min-height: 6rem;
  resize: vertical;
}

.vae-form-submit {
  align-self: flex-start;
  padding: 0.625rem 1.25rem;
  background-color: var(--vae-primary-color, #3B82F6);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.vae-form-submit:hover {
  background-color: var(--vae-primary-darker, #2563eb);
}

.vae-profile-section {
  margin: 0 0 1.5rem 0;
}

.vae-profile-title {
  font-size: 1rem;
  font-weight: 600;
  color: #4b5563;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.vae-profile-title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.375rem;
  background-color: #3B82F6;
  color: white;
}

.vae-profile-title-icon svg {
  width: 1rem;
  height: 1rem;
}

#vae-profile-cards-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, auto);
  gap: var(--vae-spacing-md, 16px);
  width: 100%;
}

.vae-profile-row {
  display: flex;
  flex-direction: row;
  gap: var(--vae-spacing-md, 16px);
  margin-bottom: 1rem;
  width: 100%;
}

.vae-profile-row .vae-profile-card {
  flex: 1;
  min-width: 0;
  width: 100%;
}

.vae-profile-card {
  background-color: var(--vae-subtle-bg);
  border: none;
  border-radius: 0.625rem;
  padding: 1rem;
  text-align: left;
  cursor: pointer;
  position: relative;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  color: var(--vae-modal-text);
  user-select: none;
}

.vae-profile-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background-color: var(--vae-modal-bg);
}

.vae-profile-card:focus {
  outline: 2px solid var(--vae-primary-color);
  outline-offset: 2px;
  box-shadow: 0 0 0 3px rgba(var(--vae-primary-rgb), 0.3);
}

.vae-profile-card.active {
  border: 1px solid var(--vae-primary-color);
  background-color: rgba(var(--vae-primary-rgb), 0.1);
  transform: translateY(-4px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.vae-profile-card.active::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 24px 24px 0;
  border-color: transparent var(--vae-primary-color) transparent transparent;
}

.vae-profile-card-icon {
  width: calc(var(--vae-profile-icon-size) + 2 * var(--vae-profile-icon-container-padding));
  height: calc(var(--vae-profile-icon-size) + 2 * var(--vae-profile-icon-container-padding));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  margin-bottom: 0.75rem;
  padding: var(--vae-profile-icon-container-padding);
}

.vae-profile-card-icon svg {
  width: var(--vae-profile-icon-size);
  height: var(--vae-profile-icon-size);
}

.vae-profile-card-title {
  font-size: 1.0625rem;
  font-weight: 500;
}

.vae-profile-card-description {
  font-size: 0.9375rem;
  color: var(--vae-footer-text);
  line-height: 1.4;
}

.vae-profile-card[data-profile="seizure"] .vae-profile-card-icon {
  background-color: #e0f2fe;
}
.vae-profile-card[data-profile="seizure"] .vae-profile-card-icon svg {
  stroke: #0ea5e9;
}

.vae-profile-card[data-profile="vision"] .vae-profile-card-icon {
  background-color: #dcfce7;
}
.vae-profile-card[data-profile="vision"] .vae-profile-card-icon svg {
  stroke: #22c55e;
}

.vae-profile-card[data-profile="adhd"] .vae-profile-card-icon {
  background-color: transparent;
}
.vae-profile-card[data-profile="adhd"] .vae-profile-card-icon svg {
  stroke: #000000;
}

.vae-profile-card[data-profile="cognitive"] .vae-profile-card-icon {
  background-color: #f3e8ff;
}
.vae-profile-card[data-profile="cognitive"] .vae-profile-card-icon svg {
  stroke: #a855f7;
}

.vae-profile-card[data-profile="motor"] .vae-profile-card-icon {
  background-color: #fff7ed;
}
.vae-profile-card[data-profile="motor"] .vae-profile-card-icon svg {
  stroke: #f97316;
}

.vae-profile-card[data-profile="dyslexia"] .vae-profile-card-icon {
  background-color: transparent;
}
.vae-profile-card[data-profile="dyslexia"] .vae-profile-card-icon svg {
  stroke: #000000;
}

.vae-profile-card[data-profile="easyLanguage"] .vae-profile-card-icon {
  background-color: #e5e0ff;
  border-radius: 0.5rem;
  padding: 0.25rem;
}
.vae-profile-card[data-profile="easyLanguage"] .vae-profile-card-icon img {
  width: var(--vae-profile-icon-size);
  height: var(--vae-profile-icon-size);
}

.vae-profile-card[data-profile="simpleLanguage"] .vae-profile-card-icon {
  background-color: #e5e0ff;
  border-radius: 0.5rem;
  padding: 0.25rem;
}
.vae-profile-card[data-profile="simpleLanguage"] .vae-profile-card-icon svg {
  stroke: #6366f1;
}

.vae-section-title-with-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 0.75rem;
}

.vae-section-title-with-dropdown h3 {
  margin-right: 12px;
  flex-shrink: 0;
  margin-bottom: 0;
}

.vae-title-dropdown-wrapper {
  max-width: 180px;
  margin-left: auto;
}

.vae-title-dropdown-wrapper .vae-select {
  width: 100%;
  font-size: 0.875rem;
  padding: 0.5rem 2rem 0.5rem 0.75rem;
}

.vae-title-dropdown-wrapper::after {
  right: 0.75rem;
}

@media (max-width: 480px) {
  .vae-section-title-with-dropdown {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .vae-title-dropdown-wrapper {
    margin-top: 8px;
    margin-left: 0;
    max-width: 100%;
    width: 100%;
  }
}

.vae-overlay-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 999;
}

.vae-modal-centering-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 1.5rem;
  box-sizing: border-box;
}

.vae-modal-dialog-content-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  background-color: var(--vae-modal-bg, white);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  border-radius: 0.5rem;
  overflow: hidden; 
}

.vae-modal-dialog-content-box > .vae-overlay-header {
  padding: 0.75rem var(--vae-container-padding, 1rem);
  border-bottom: 1px solid var(--vae-border-light, #e5e5e5);
  background-color: transparent;
}

.vae-modal-dialog-content-box > .vae-overlay-content {
  padding: var(--vae-content-padding, 1rem);
  flex: initial;
}

#vae-privacy-withdraw-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

#vae-privacy-withdraw-actions .vae-button {
  margin-left: 0;
}

#vae-privacy-consent-declaration-text {
  height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 15px;
}

#vae-privacy-consent-actions {
  text-align: center;
}

#vae-privacy-consent-actions .vae-button#vae-privacy-decline-button {
  margin-left: 10px;
  background-color: #6c757d;
}

#vae-privacy-withdraw-actions .vae-button#vae-privacy-withdraw-button {
  background-color: #dc3545;
}
`, "",{"version":3,"sources":["webpack://./widget/assets/css/ui-shared.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,2EAA2E;EAC3E,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gCAAgC;EAChC,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mDAAmD;EACnD,yDAAyD;EACzD,4CAA4C;EAC5C,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;;EAEE,iBAAiB;EACjB,kDAAkD;EAClD,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,4CAA4C;EAC5C,wDAAwD;EACxD,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,+CAA+C;EAC/C,sEAAsE;AACxE;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mDAAmD;EACnD,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iFAAiF;EACjF,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,0CAA0C;EAC1C,mDAAmD;EACnD,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,0EAA0E;AAC5E;;AAEA;EACE,yFAAyF;EACzF,0FAA0F;EAC1F,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,0BAA0B;EAC1B,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,0CAA0C;EAC1C,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,yDAAyD;EACzD,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".vae-card {\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  margin-bottom: 1rem;\n  overflow: hidden;\n}\n\n.vae-card-header {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #1f2937;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #e5e7eb;\n  margin: 0;\n  background-color: #f9fafb;\n}\n\n.vae-card-content {\n  padding: 1rem;\n}\n\n.vae-stepper-value {\n  min-width: 4rem;\n  text-align: center;\n  font-weight: 500;\n  font-size: 1rem;\n  color: #111827;\n  padding: 0 0.25rem;\n}\n\n.vae-card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.vae-numeric-stepper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n}\n\n.vae-stepper-label {\n  margin-right: 1rem;\n  font-weight: 450;\n  font-size: 1rem;\n  color: #4b5563;\n}\n\n.vae-stepper-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.vae-stepper-button {\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  color: #374151;\n  width: 2rem;\n  height: 2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.375rem;\n  font-weight: bold;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.vae-stepper-button:hover {\n  background-color: #f3f4f6;\n}\n\n.vae-stepper-button:active {\n  background-color: #e5e7eb;\n}\n\n.vae-stepper-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background-color: #f9fafb;\n}\n\n.vae-dropdown-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n}\n\n.vae-dropdown-label {\n  margin-right: 1rem;\n  font-weight: 450;\n  font-size: 1rem;\n  color: #4b5563;\n  flex-shrink: 0;\n}\n\n.vae-select-wrapper {\n  position: relative;\n  display: inline-block;\n  max-width: 320px;\n}\n\n.vae-select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 100%;\n  padding: 0.5rem 2rem 0.5rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #111827;\n  background-color: #ffffff;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.vae-select:hover {\n  border-color: #9ca3af;\n}\n\n.vae-select:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);\n}\n\n.vae-select-wrapper::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 1rem;\n  width: 0;\n  height: 0;\n  margin-top: -2px;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 5px solid #6b7280;\n  pointer-events: none;\n}\n\n.vae-select-wrapper:hover::after {\n    border-top-color: #374151;\n}\n\n.vae-switch-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n}\n\n.vae-switch-label {\n  margin-right: 1rem;\n  font-weight: 500;\n  color: #374151;\n  font-size: 0.9rem;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.vae-label-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.vae-control-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  color: #4b5563;\n}\n\n.vae-control-icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.vae-numeric-stepper,\n.vae-dropdown-container,\n.vae-switch-container {\n  background-color: #f9fafb;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 8px;\n}\n\n.vae-text-settings-container {\n  background-color: #f9fafb;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.vae-text-settings-container .vae-numeric-stepper,\n.vae-text-settings-container .vae-dropdown-container {\n  background-color: transparent;\n  border-radius: 0;\n  padding: 4px 0;\n  margin-bottom: 4px;\n}\n\n.vae-text-settings-container > *:last-child {\n  margin-bottom: 0;\n}\n\n.vae-stepper-label,\n.vae-dropdown-label,\n.vae-switch-label {\n  margin-right: 0;\n  font-weight: 450;\n  font-size: 0.9rem;\n  color: #4b5563;\n}\n\n.vae-switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 22px;\n  background-color: #ccc;\n  border-radius: 34px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  border: 1px solid #ccc;\n  padding: 0;\n  appearance: none;\n  -webkit-appearance: none;\n  outline: none;\n  box-sizing: content-box;\n}\n\n.vae-switch:focus-visible {\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);\n}\n\n.vae-switch-knob {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  border-radius: 50%;\n  transition: transform 0.2s;\n}\n\n.vae-switch-checked {\n  background-color: #2563eb;\n  border-color: #2563eb;\n}\n\n.vae-switch-checked .vae-switch-knob {\n  transform: translateX(18px);\n}\n\n.vae-numeric-stepper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.vae-overlay {\n  position: relative;\n  top: auto;\n  left: auto;\n  right: auto;\n  bottom: auto;\n  background-color: var(--vae-modal-bg, white);\n  z-index: 10;\n  display: none;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n  max-height: none;\n  min-height: 0;\n}\n\n.vae-overlay.active {\n  display: flex;\n}\n\n.vae-overlay-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem var(--vae-container-padding, 1rem);\n  border-bottom: 1px solid var(--vae-border-light, #e5e5e5);\n  background-color: var(--vae-modal-bg, white);\n  z-index: 2;\n  position: relative;\n}\n\n.vae-overlay-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--vae-modal-text, #262626);\n}\n\n.vae-overlay-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  color: var(--vae-footer-text, #6b7280);\n  position: static;\n  top: auto;\n  right: auto;\n  z-index: 1;\n  gap: 0.5rem;\n}\n\n.vae-overlay-close svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.vae-back-text {\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.vae-overlay-close:hover {\n  color: var(--vae-modal-text, #262626);\n  background-color: transparent;\n}\n\n.vae-overlay-content {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  padding: var(--vae-content-padding, 1rem);\n}\n\n.vae-overlay-content p {\n  margin-bottom: 1rem;\n  line-height: 1.5;\n  color: var(--vae-modal-text-secondary, #4b5563);\n}\n\n.vae-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.vae-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.vae-form-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--vae-modal-text-secondary, #4b5563);\n}\n\n.vae-form-input,\n.vae-form-textarea {\n  padding: 0.625rem;\n  border: 1px solid var(--vae-border-light, #d1d5db);\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  color: var(--vae-modal-text, #111827);\n  background-color: var(--vae-bg-light, white);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  font-family: inherit;\n}\n\n.vae-form-input:focus,\n.vae-form-textarea:focus {\n  outline: none;\n  border-color: var(--vae-primary-color, #3B82F6);\n  box-shadow: 0 0 0 2px rgba(var(--vae-primary-rgb, 59, 130, 246), 0.25);\n}\n\n.vae-form-textarea {\n  min-height: 6rem;\n  resize: vertical;\n}\n\n.vae-form-submit {\n  align-self: flex-start;\n  padding: 0.625rem 1.25rem;\n  background-color: var(--vae-primary-color, #3B82F6);\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.vae-form-submit:hover {\n  background-color: var(--vae-primary-darker, #2563eb);\n}\n\n.vae-profile-section {\n  margin: 0 0 1.5rem 0;\n}\n\n.vae-profile-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #4b5563;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.vae-profile-title-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 0.375rem;\n  background-color: #3B82F6;\n  color: white;\n}\n\n.vae-profile-title-icon svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n#vae-profile-cards-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(3, auto);\n  gap: var(--vae-spacing-md, 16px);\n  width: 100%;\n}\n\n.vae-profile-row {\n  display: flex;\n  flex-direction: row;\n  gap: var(--vae-spacing-md, 16px);\n  margin-bottom: 1rem;\n  width: 100%;\n}\n\n.vae-profile-row .vae-profile-card {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n}\n\n.vae-profile-card {\n  background-color: var(--vae-subtle-bg);\n  border: none;\n  border-radius: 0.625rem;\n  padding: 1rem;\n  text-align: left;\n  cursor: pointer;\n  position: relative;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n  color: var(--vae-modal-text);\n  user-select: none;\n}\n\n.vae-profile-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  background-color: var(--vae-modal-bg);\n}\n\n.vae-profile-card:focus {\n  outline: 2px solid var(--vae-primary-color);\n  outline-offset: 2px;\n  box-shadow: 0 0 0 3px rgba(var(--vae-primary-rgb), 0.3);\n}\n\n.vae-profile-card.active {\n  border: 1px solid var(--vae-primary-color);\n  background-color: rgba(var(--vae-primary-rgb), 0.1);\n  transform: translateY(-4px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);\n}\n\n.vae-profile-card.active::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 24px 24px 0;\n  border-color: transparent var(--vae-primary-color) transparent transparent;\n}\n\n.vae-profile-card-icon {\n  width: calc(var(--vae-profile-icon-size) + 2 * var(--vae-profile-icon-container-padding));\n  height: calc(var(--vae-profile-icon-size) + 2 * var(--vae-profile-icon-container-padding));\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.5rem;\n  margin-bottom: 0.75rem;\n  padding: var(--vae-profile-icon-container-padding);\n}\n\n.vae-profile-card-icon svg {\n  width: var(--vae-profile-icon-size);\n  height: var(--vae-profile-icon-size);\n}\n\n.vae-profile-card-title {\n  font-size: 1.0625rem;\n  font-weight: 500;\n}\n\n.vae-profile-card-description {\n  font-size: 0.9375rem;\n  color: var(--vae-footer-text);\n  line-height: 1.4;\n}\n\n.vae-profile-card[data-profile=\"seizure\"] .vae-profile-card-icon {\n  background-color: #e0f2fe;\n}\n.vae-profile-card[data-profile=\"seizure\"] .vae-profile-card-icon svg {\n  stroke: #0ea5e9;\n}\n\n.vae-profile-card[data-profile=\"vision\"] .vae-profile-card-icon {\n  background-color: #dcfce7;\n}\n.vae-profile-card[data-profile=\"vision\"] .vae-profile-card-icon svg {\n  stroke: #22c55e;\n}\n\n.vae-profile-card[data-profile=\"adhd\"] .vae-profile-card-icon {\n  background-color: transparent;\n}\n.vae-profile-card[data-profile=\"adhd\"] .vae-profile-card-icon svg {\n  stroke: #000000;\n}\n\n.vae-profile-card[data-profile=\"cognitive\"] .vae-profile-card-icon {\n  background-color: #f3e8ff;\n}\n.vae-profile-card[data-profile=\"cognitive\"] .vae-profile-card-icon svg {\n  stroke: #a855f7;\n}\n\n.vae-profile-card[data-profile=\"motor\"] .vae-profile-card-icon {\n  background-color: #fff7ed;\n}\n.vae-profile-card[data-profile=\"motor\"] .vae-profile-card-icon svg {\n  stroke: #f97316;\n}\n\n.vae-profile-card[data-profile=\"dyslexia\"] .vae-profile-card-icon {\n  background-color: transparent;\n}\n.vae-profile-card[data-profile=\"dyslexia\"] .vae-profile-card-icon svg {\n  stroke: #000000;\n}\n\n.vae-profile-card[data-profile=\"easyLanguage\"] .vae-profile-card-icon {\n  background-color: #e5e0ff;\n  border-radius: 0.5rem;\n  padding: 0.25rem;\n}\n.vae-profile-card[data-profile=\"easyLanguage\"] .vae-profile-card-icon img {\n  width: var(--vae-profile-icon-size);\n  height: var(--vae-profile-icon-size);\n}\n\n.vae-profile-card[data-profile=\"simpleLanguage\"] .vae-profile-card-icon {\n  background-color: #e5e0ff;\n  border-radius: 0.5rem;\n  padding: 0.25rem;\n}\n.vae-profile-card[data-profile=\"simpleLanguage\"] .vae-profile-card-icon svg {\n  stroke: #6366f1;\n}\n\n.vae-section-title-with-dropdown {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 0.75rem;\n}\n\n.vae-section-title-with-dropdown h3 {\n  margin-right: 12px;\n  flex-shrink: 0;\n  margin-bottom: 0;\n}\n\n.vae-title-dropdown-wrapper {\n  max-width: 180px;\n  margin-left: auto;\n}\n\n.vae-title-dropdown-wrapper .vae-select {\n  width: 100%;\n  font-size: 0.875rem;\n  padding: 0.5rem 2rem 0.5rem 0.75rem;\n}\n\n.vae-title-dropdown-wrapper::after {\n  right: 0.75rem;\n}\n\n@media (max-width: 480px) {\n  .vae-section-title-with-dropdown {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .vae-title-dropdown-wrapper {\n    margin-top: 8px;\n    margin-left: 0;\n    max-width: 100%;\n    width: 100%;\n  }\n}\n\n.vae-overlay-backdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  z-index: 999;\n}\n\n.vae-modal-centering-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 1.5rem;\n  box-sizing: border-box;\n}\n\n.vae-modal-dialog-content-box {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 500px;\n  background-color: var(--vae-modal-bg, white);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  border-radius: 0.5rem;\n  overflow: hidden; \n}\n\n.vae-modal-dialog-content-box > .vae-overlay-header {\n  padding: 0.75rem var(--vae-container-padding, 1rem);\n  border-bottom: 1px solid var(--vae-border-light, #e5e5e5);\n  background-color: transparent;\n}\n\n.vae-modal-dialog-content-box > .vae-overlay-content {\n  padding: var(--vae-content-padding, 1rem);\n  flex: initial;\n}\n\n#vae-privacy-withdraw-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n#vae-privacy-withdraw-actions .vae-button {\n  margin-left: 0;\n}\n\n#vae-privacy-consent-declaration-text {\n  height: 200px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-bottom: 15px;\n}\n\n#vae-privacy-consent-actions {\n  text-align: center;\n}\n\n#vae-privacy-consent-actions .vae-button#vae-privacy-decline-button {\n  margin-left: 10px;\n  background-color: #6c757d;\n}\n\n#vae-privacy-withdraw-actions .vae-button#vae-privacy-withdraw-button {\n  background-color: #dc3545;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
